import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout, COMPANY } from "@/components/site/LegalLayout";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Cookiestatement — Elvion Group Nederland" },
      { name: "description", content: "Cookiestatement van Elvion Group Nederland: welke functionele, analytische en marketingcookies wij plaatsen, waarvoor ze dienen en hoe u uw voorkeuren beheert." },
      { property: "og:title", content: "Cookiestatement — Elvion Group Nederland" },
      { property: "og:description", content: "Lees welke cookies Elvion Group Nederland gebruikt, waarom en hoe u ze eenvoudig kunt aanpassen of weigeren via uw browser en onze cookie-instellingen." },
      { name: "robots", content: "index,follow" },
      { property: "og:url", content: "https://elvion-group.nl/cookies" },
    ],
    links: [{ rel: "canonical", href: "https://elvion-group.nl/cookies" }],
  }),
  component: () => (
    <LegalLayout title="Cookiestatement" intro={`Op de website van ${COMPANY.name} maken wij gebruik van cookies. Hieronder leggen wij uit welke cookies wij plaatsen en waarom.`}>
      <h2>Wat zijn cookies?</h2>
      <p>Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen op uw computer, tablet of smartphone.</p>

      <h2>Welke cookies gebruiken wij?</h2>
      <h3>Functionele cookies (altijd geplaatst)</h3>
      <p>Noodzakelijk voor de werking van de website, zoals het onthouden van uw winkelmandje en inlogsessie. Geen toestemming vereist.</p>

      <h3>Analytische cookies</h3>
      <p>Wij gebruiken privacyvriendelijke analytics om het gebruik van onze site te meten en te verbeteren. Deze cookies hebben geen of geringe gevolgen voor uw privacy.</p>

      <h3>Marketing- en tracking cookies</h3>
      <p>Worden uitsluitend geplaatst na uw toestemming. Deze cookies volgen uw surfgedrag zodat wij relevantere content en advertenties kunnen tonen.</p>

      <h2>Cookies uitschakelen of verwijderen</h2>
      <p>U kunt cookies te allen tijde verwijderen of blokkeren via de instellingen van uw browser. Het uitschakelen van functionele cookies kan ertoe leiden dat onderdelen van de website niet meer werken.</p>

      <h2>Wijzigingen</h2>
      <p>Wij behouden ons het recht voor dit cookiestatement te wijzigen. Raadpleeg deze pagina regelmatig.</p>

      <h2>Contact</h2>
      <p>Vragen? Mail {COMPANY.email}.</p>
    </LegalLayout>
  ),
});
